import React, {useState, useEffect, useRef} from 'react';

import './homepage.styles.css';
import Header from '../../components/header/header.components';
import GlavneNajave from '../../components/glavnenajave/glavnenajave.components';
import AboutSection from '../../components/aboutsection/aboutsection.components';
import MediaSection from '../../components/mediasection/mediasection.component';
import IzvestajiSection from '../../components/izvestajisection/izvestajisection.components';
import Footer from '../../components/footer/footer.component';

import {useHttpClient} from '../../utils/input/http-hook';



const HomePage = () => {

    
  
  const myRef = useRef(null)  
  const scrollToRef = (ref) => window.scrollTo(0, ref.current.offsetTop)  
  const executeScroll = () => scrollToRef(myRef)

    const { isLoading, error, sendRequest, clearError } = useHttpClient();
    const [loadedIzvestaji, setLoadedIzvestaji] = useState(); 
    const [loadedNajave, setLoadedNajave] = useState();       

    const [randomImages, setRandomImages] = useState( 
      ['img/nat-1', 'img/nat-2', 'img/nat-3', 'img/nat-4' ,'img/nat-5', 'img/nat-6', 'img/nat-7','img/nat-8', 'img/nat-9', 'img/nat-10',
       'img/nat-11', 'img/nat-12', 'img/nat-13', 'img/nat-14', 'img/nat-15', 'img/nat-16', 'img/nat-17', 'img/nat-18', 'img/nat-19', 'img/nat-20']
      )

    useEffect(() => { 
      const shuffled = randomImages.sort(function(){return .5 - Math.random()});    
      const selected=shuffled.slice(0,3);      
         setRandomImages(selected);
      }, []);

    useEffect(() => {    
      const fetchIzvestaji = async () => {
        try {
          const responseData = await sendRequest(
            process.env.REACT_APP_BECKEND_URL+'/izvestaji?limit=2'
          );            
  
          setLoadedIzvestaji(responseData.izvestaji);
        } catch (err) {}
      };
      fetchIzvestaji();
     
    }, [sendRequest]);

    useEffect(() => {
        const fetchNajave = async () => {
          try {
            const responseData = await sendRequest(
              process.env.REACT_APP_BECKEND_URL+'/najave?limit=3'
            );            
    
            setLoadedNajave(responseData.najave);
          } catch (err) {}
        };
        fetchNajave();
       
      }, [sendRequest]);      
        


    
    return(
     
    <div className="homepage">

       <Header  scrollTo={executeScroll} />
        <main>
            <AboutSection images={randomImages}/>            
            <MediaSection  />
            <div ref={myRef}>
            <GlavneNajave najave = {loadedNajave} />
            </div>
          
            <IzvestajiSection items={loadedIzvestaji} />
        </main>
        <Footer />


       
    </div>
);
}

export default HomePage;